import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL;

export const addTutor = async (newTutor, user, period) => {
  const config = {
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    };
  
  const body = {
    "id": newTutor.id,
    "name": newTutor.name,
    "last_name": newTutor.last_name,
    "email": newTutor.email,
    "period": period,
    "capacity": newTutor.capacity
  }
  try {
    const url = `${BASE_URL}/tutors`;
    const response = await axios.post(url, body, config);
    return response.data;
  } catch (err) {
    console.error(`Error when adding new tutor: ${err}`)
    throw new Error(err);
  }
};

export const editTutor = async (original_tutor_id, period_id, tutorToEdit, user) => {
  const config = {
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    };

    // Esto es necesario porque, si no, el ítem tutor tiene más campos (como tutor_periods)
    // que el back No espera.
    const sendableTutorToEdit = {
      "id": tutorToEdit.id,
      "name": tutorToEdit.name,
      "last_name": tutorToEdit.last_name,
      "email": tutorToEdit.email,
      "capacity": tutorToEdit.capacity
    };
  try {
      const url = `${BASE_URL}/tutors/${original_tutor_id}/periods/${period_id}`;
      const response = await axios.patch(url, sendableTutorToEdit, config);

      return response.data;
  } catch (err) {
      console.error(`Error when editing tutor: ${err}`)
      throw new Error(err);
  }
};

// Los errores del back vienen en `detail`; lo propagamos para mostrar el
// motivo real en lugar de un mensaje generico (mismo patron que handleAdmins).
const errorFrom = (err, fallback) => {
  const detail = err?.response?.data?.detail;
  return new Error(typeof detail === "string" ? detail : fallback);
};

// Base de posibles directores: todos los tutores con su ficha (telefono,
// cargo, departamento) y, por cuatrimestre, cuantos grupos dirigieron y
// evaluaron. Solo admins.
export const getTutorDirectory = async (user) => {
  try {
    const response = await axios.get(`${BASE_URL}/tutors/directory`, {
      headers: { Authorization: `Bearer ${user.token}` },
    });
    return response.data;
  } catch (err) {
    console.error(`Error when getting tutor directory: ${err}`);
    throw errorFrom(err, "Error al obtener la base de directores");
  }
};

// La ficha es del usuario, no de un cuatrimestre: por eso no va a
// /tutors/{id}/periods/{period} como editTutor. El PATCH es parcial: los
// campos ausentes no se tocan, y "" en phone lo borra.
export const editTutorProfile = async (tutorId, profile, user) => {
  const body = {};
  if (profile.phone !== undefined) body.phone = profile.phone;
  if (profile.position) body.position = profile.position;
  if (profile.department) body.department = profile.department;
  try {
    const response = await axios.patch(
      `${BASE_URL}/tutors/${tutorId}/profile`,
      body,
      { headers: { Authorization: `Bearer ${user.token}` } }
    );
    return response.data;
  } catch (err) {
    console.error(`Error when editing tutor profile: ${err}`);
    throw errorFrom(err, "Error al editar la ficha del director");
  }
};
